import { useCallback } from "react";
import {
  ApolloError,
  ApolloQueryResult,
  useApolloClient,
  gql,
} from "@apollo/client";
import { GetUsers_getUsers } from "../__generated__/gql-types/GetUsers";
import { Roles } from "../__generated__/gql-types/globalTypes";

export interface UserFilters {
  search?: string;
  limit?: number;
  offset?: number;
  role?: Roles;
}

export interface UsersWithFiltersResponse {
  users: GetUsers_getUsers[];
  totalCount: number;
  hasMore: boolean;
  currentPage: number;
  totalPages: number;
}

const UseGetUsersWithFilters = () => {
  const client = useApolloClient();

  return useCallback(async (filters: UserFilters = {}): Promise<UsersWithFiltersResponse> => {
    const result: ApolloQueryResult<{ getUsersWithFiltersAndPagination: UsersWithFiltersResponse }> = await client.query({
      query: GET_USERS_WITH_FILTERS_AND_PAGINATION,
      variables: {
        filters: {
          search: filters.search || null,
          limit: filters.limit ?? 10,
          offset: filters.offset ?? 0,
          role: filters.role || null,
        }
      },
      fetchPolicy: "no-cache",
    });

    if (result.error) {
      throw new ApolloError({
        graphQLErrors: result.errors,
      });
    }
    return result.data.getUsersWithFiltersAndPagination;
  }, [client]);
};

export default UseGetUsersWithFilters;

const GET_USERS_WITH_FILTERS_AND_PAGINATION = gql`
  query GetUsersWithFiltersAndPagination($filters: UsersFilterInput) {
    getUsersWithFiltersAndPagination(filters: $filters) {
      users {
        id
        email
        first_name
        last_name
        role
        created_at
        schools {
          name
          id
        }
      }
      totalCount
      hasMore
      currentPage
      totalPages
    }
  }
`;
